import { useTranslation } from "react-i18next";
import {
	ToggleGroup,
	ToggleGroupItem,
} from "@/src/lib/components/ui/toggle-group";

export default function LanguageToggle() {
	const { i18n, t } = useTranslation();

	return (
		<ToggleGroup
			className="bg-card border"
			type="single"
			value={i18n.language}
			onValueChange={(value) => value && i18n.changeLanguage(value)}
		>
			<ToggleGroupItem
				value="de"
				aria-label={t("settings.language.toggle_german")}
			>
				{t("settings.language.deutsch")}
			</ToggleGroupItem>
			<ToggleGroupItem
				value="en"
				aria-label={t("settings.language.toggle_english")}
			>
				{t("settings.language.english")}
			</ToggleGroupItem>
		</ToggleGroup>
	);
}
